import dayjs from "dayjs";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateProject } from "~/api/folders/folders";
import { LoaderWithSteps } from "~/components/LoaderWithSteps";
import { PageLayout } from "~/components/PageLayout";
import {
  DEMO_CASE_NAME,
  DEMO_CASE_STEPS,
  SKY_ACCOUNT_CREATED,
  SKY_LAST_TRANSCRIBED_TEXT,
} from "~/constants/index";
import { ROUTES, useOrganizationParams } from "~/helpers";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const DemoCaseGenerationPage = () => {
  useTrackPageVisit("app/demo-case-generation/visit");
  const navigate = useNavigate();

  const { mutate } = useCreateProject();
  const { organizationId } = useOrganizationParams();

  const isNewAccount = localStorage.getItem(SKY_ACCOUNT_CREATED) === "true";
  const transcribingText = localStorage.getItem(SKY_LAST_TRANSCRIBED_TEXT);

  useEffect(() => {
    if (!isNewAccount && (!transcribingText || transcribingText?.length < 1)) {
      navigate("/");
    } else {
      generateDemoCase();
    }
  }, [transcribingText, isNewAccount, navigate]);

  const generateDemoCase = () => {
    const body = {
      name: DEMO_CASE_NAME,
      claimNumber: "1",
      dateOfBirth: dayjs(new Date()).format("YYYY-MM-DD"),
    };

    mutate(
      {
        organizationId,
        data: body,
      },
      {
        onSuccess: (createdCase) => {
          setTimeout(() => {
            navigate(
              ROUTES.DEMO_CASE_UPLOAD({
                organizationId,
                caseId: createdCase.id,
              })
            );
          }, 1000);
        },
      }
    );
  };

  return (
    <PageLayout>
      <div className="w-full h-[85vh] flex flex-col items-center justify-center">
        <LoaderWithSteps steps={DEMO_CASE_STEPS} currentStep={0} />
      </div>
    </PageLayout>
  );
};
